import $ from "expose-loader?exposes=$,jQuery!jquery";

if (window.scan && window.scan.mindfulCallbackWidgetScriptSource) {
    $(function () {
        $.getScript(window.scan.mindfulCallbackWidgetScriptSource, function (response, status) {
        });
    });
}
